// extracted by mini-css-extract-plugin
export default {"placeholder":"LocationsListPage_placeholder__ep5DW"};